import React from 'react';
import { Slider } from '../slider/Slider';
import { TestimonialList } from './TestimonialList';

export class TestimonialSlider extends React.Component {
    constructor(props) {
        super(props);
        //todo: implement view all testimonials vs view them as a slide show
    }

    render() {
        return (
            <React.Fragment>
                <h2>
                    {this.props.title}
                </h2>
                <Slider
                    parentSelector='#testimonialsSlider'
                >
                    {this.props.children}
                </Slider>
            </React.Fragment>
        );
    }
}